export const USER_REVISION_CHECK_REFRESH = 30000;

export const REWARD_QUEST_TYPE = {
    TIER_UPGRADE: 'tier_upgrade',
    SUBSCRIPTION_RENEWAL: 'renew_subscription',
};

export const REDEEM_QUEST_TYPE = {
    TVOD: 'tvod',
    UPGRADE: 'upgrade',
};
